interface IconProps {
    size?: number;
}

export default function ClaudeIcon({ size = 16 }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
            <path d="M12 2v8.5" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M12 13.5V22" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M5.1 5.1l4.6 4.6" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M14.3 14.3l4.6 4.6" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M2 12h8.5" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M13.5 12H22" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M5.1 18.9l4.6-4.6" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
            <path d="M14.3 9.7l4.6-4.6" stroke="#D97757" strokeWidth="3" strokeLinecap="round" />
        </svg>
    );
}
